import ActionHelper from 'helpers/action'

// constants
export const FETCH_FILTERS = 'myJobsDataViewer/FETCH_FILTERS'
export const LOAD_FILTERS = 'myJobsDataViewer/LOAD_FILTERS'
export const SET_FILTERS = 'myJobsDataViewer/SET_FILTERS'
export const CLEAR_FILTERS = 'myJobsDataViewer/CLEAR_FILTERS'

export const FETCH_TABLE_DATA = 'myJobsDataViewer/FETCH_TABLE_DATA'
export const LOAD_TABLE_DATA = 'myJobsDataViewer/LOAD_TABLE_DATA'
export const SET_TABLE_DATA = 'myJobsDataViewer/SET_TABLE_DATA'
export const CLEAR_TABLE_DATA = 'myJobsDataViewer/CLEAR_TABLE_DATA'
export const EXPORT_TO_CSV = 'myJobsDataViewer/EXPORT_TO_CSV'

export const SET_INIT_FILTERS = 'myJobsDataViewer/SET_INIT_FILTERS'
export const SET_ACTIVE_FILTER = 'myJobsDataViewer/SET_ACTIVE_FILTER'
export const SET_INIT_READY_STATE = 'myJobsDataViewer/SET_INIT_READY_STATE'

export const CLEAR_STORE = 'myJobsDataViewer/CLEAR_STORE'

// actions
export const fetchFilters = ActionHelper.createActionObj(FETCH_FILTERS)
export const setInitReadyState = ActionHelper.createActionObj(
  SET_INIT_READY_STATE,
)
export const setFilters = ActionHelper.createActionObj(SET_FILTERS)
export const setInitFilters = ActionHelper.createActionObj(SET_INIT_FILTERS)
export const setActiveFilter = ActionHelper.createActionObj(SET_ACTIVE_FILTER)
export const fetchTableData = ActionHelper.createActionObj(FETCH_TABLE_DATA)
export const exportToCsv = ActionHelper.createActionObj(EXPORT_TO_CSV)
export const clearStore = ActionHelper.createActionObj(CLEAR_STORE)
